import React,{useState, useEffect} from 'react'
import ModalInformativo from '../generales/ModalInformativo'
import TablaGeneral from './TablaGeneral'
import moment from 'moment'
import {Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
        Card,Box, Typography, IconButton, Tooltip, TablePagination,LinearProgress,
        TextField} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import NumberFormat from 'react-number-format';
import { useHistory } from "react-router-dom";
import { obtenDispo } from '../funciones/IdDispositivo';
import axios from 'axios';
import qs from 'qs';
import XLSX from 'xlsx';
import SaveIcon from '@material-ui/icons/Save';
import PaginacionTab from '../layout/PaginacionTab'
import { numeroPag } from "../funciones/Paginacion";
import {ErrorGeneral, llamaApiCargaToken,} from "../funciones/ClienteAxios";
import MapaLeafAvanceUsuario from './MapaLeafAvUsu';
const useStyles = makeStyles({
    estiloCard:{
      width: '32rem',
      boxShadow:'0 0.5em 1em -0.125em rgb(10 10 10 / 10%), 0 0 0 1px rgb(10 10 10 / 2%)',
      // color:'#4a4a4a',
      display:'block',
      padding:'.5rem',
      maxHeight:'100%',
      minHeight: 280,
      marginRight:'.5rem'
    },
    tablaContainer: {
      width: '30.5rem',
      maxHeight: '24rem',
      minHeight: 280,
      //minWidth:'100%',
    },
    totalEstilo:{
      fontSize:'1.25rem',
      fontWeight:'bold'
    },
    tituloEstilo:{
      paddingBottom:'.25rem',
      fontWeight:'bold'
    },
    tableRow: {
      "&$selected, &$selected:hover": {
        backgroundColor:process.env.REACT_APP_Color_Second
      }
    },
    tableCell: {
      "$selected &": {
        color: "white"
      } 
    },
    hover: {},
    selected: {}
  });

const ModalAvanceUsuario = ({setModalAbierto,modalAbierto,titulo, fSelect, }) => {
    const classes = useStyles();      
    let history = useHistory(); 
    const tamMax=150
    const auxCol=process.env.REACT_APP_Fondo_Color  
    const idusu = localStorage.getItem("UsuId")?parseInt(localStorage.getItem("UsuId")):0;    
    const auxDispV =obtenDispo()  
    const [datos,setDatos] = useState([]);     
    const source = axios.CancelToken.source(); 
    const [totalGen,setTotalGen] = useState([]);     
    const [registro, setRegistro] = useState([]) 
    const [espera, setEspera] = useState(false) 
    const [esperaMap, setEsperaMap] = useState(false) 
    const [listaExcel, setListaExcel] = useState([]);
    const [totalPaginas,setTotalPaginas]=useState(0);
    const [numPagina,setNumPagina]=useState(0);
    const [listPagina,setListPagina]=useState([]);
    const [listMap, setListMap]=useState([]);
    const [nombre,setNombre]=useState("");
    const fInicio=moment(fSelect.inicio).format("DD/MM/YYYY");
    const fFinal=moment(fSelect.final).format("DD/MM/YYYY");   
    
    useEffect(()=>{    
      //console.log(auxSecc);
      getList()
    
          
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])          
    
    const exportarArch = () => {
      let today = new Date();                    
      let fec = moment(today);        
      //console.log(listaExcel);
      const ws = XLSX.utils.aoa_to_sheet(listaExcel);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Reporte");
      XLSX.writeFile(wb,`${fec.format("YYMMDDHHmmss")} Lista de Avance Usuario.xlsx` )
    }; 
    
  function filtro(){        
    let auxCadena=nombre.trim();       
    let info=[];                        
    let aux=  datos.filter((dat)=>dat.nom.toUpperCase().search(auxCadena.toUpperCase() ) !== -1)         
    info=aux 
        
    return info.length!==0? TablaEstr(info) : sinDatos();
  }

  const getList = () => {
    const idusu = localStorage.getItem("UsuId")?parseInt(localStorage.getItem("UsuId")):0;    
    const fInicio=moment(fSelect.inicio).format("YYYY-MM-DD");
    const fFinal=moment(fSelect.final).format("YYYY-MM-DD");   
    const data = qs.stringify({   
        Usuario:idusu,           
        Distrito:0,
        FIni:`${fInicio}T00:00:00`,
        FFin:`${fFinal}T23:59:59`,
        idDispositivo: auxDispV,
    });
    const url = "perfil/v2/captura/usuario";
  
    function respuesta(aux) {
      if (aux && aux.length!==0 &&aux[0].id!==-1 && aux[0].id !== "-1") 
      {
        let total=0
        const arrM=[]
        arrM.push(["Total", "Nombre"])
        aux.forEach((element,index) => {
            total+=element.total
            arrM.push([element.avc, element.nom])
        });
        setDatos(aux)  
        setListaExcel(arrM)
        numeroPag(aux,tamMax,setTotalPaginas,setNumPagina,setListPagina)    
        setTotalGen({Total:total})
      } 
      else{
        setListaExcel([])
        setDatos([])
        setListPagina([])
      }      
    }
  
    llamaApiCargaToken(data, url, respuesta, ErrorGeneral, setEspera, history, source);
  }; 
    
  const getListMap = (encuestador) => {
    const idusu = localStorage.getItem("UsuId")?parseInt(localStorage.getItem("UsuId")):0;    
    const fInicio=moment(fSelect.inicio).format("YYYY-MM-DD");
    const fFinal=moment(fSelect.final).format("YYYY-MM-DD");   
    const data = qs.stringify({   
        usuario:idusu,           
        status:1,
        estado:2,
        municipio:26,
        encuestador:encuestador,
        fini:`${fInicio}T00:00:00`,
        ffin:`${fFinal}T23:59:59`,
        idDispositivo: auxDispV,
    });
    const url = "perfil/v1/distrito/usuario/lista";
  
    function respuesta(aux) {
      if (aux && aux.length!==0) 
      {
        setTimeout(() => {
        setListMap(aux)    
        }, 400);
        setListMap([])  
      } 
            
    }
  
    llamaApiCargaToken(data, url, respuesta, ErrorGeneral, setEsperaMap, history, source);
  }; 

  const onChangeTable =(regis)=>{       
    setRegistro(regis)       
    getListMap(regis.id)                    
  }
    
    const sinDatos=()=>{return<Box style={{paddingTop:1+'rem', width:"40rem"}}>
                        <Typography variant="h5" component="h5">No contiene datos</Typography>
                    </Box>}
      const celda = (alinear, estilo, contenido,index) => {
        return (
        <TableCell align={alinear} key={index} className={classes.tableCell} 
          padding={'none'} style={estilo} >
          {contenido}
        </TableCell>)
      }
    
      const CelTitl=({index,titulo,aline,estilo})=> celda(aline?aline:"center", {...estilo,backgroundColor:auxCol,color:'white',}, titulo?titulo:"",index) 
    
      function onChangePagina(event, newPage){
        event.preventDefault();
        if (newPage ===0) 
        {
          setListPagina(datos.slice(0,tamMax))   
        }
        else
        {
          setListPagina(datos.slice(newPage * tamMax, newPage * tamMax + tamMax))   
        }
        setNumPagina(newPage)
      }
    
      function generarFooter(){
        return(
        <TablePagination 
          rowsPerPageOptions={false}  style={{padding:0}}
          rowsPerPage={tamMax} count={datos.length}
          page={numPagina} lang='es'
          labelDisplayedRows={
              ({ from, to, count }) => {
                return '' + from + '-' + to + ' de ' + count
              }
            }
          onPageChange={onChangePagina}
          ActionsComponent={PaginacionTab}/>)
      }

    const onChangeNom = e =>
	{   let expNopermitida = new RegExp('[0-9$.@#_&-+()/:;!?,<>=%{}*|`]');  
        let expMenos = new RegExp("'");
        let expMas = new RegExp('"');             
        let expCadena = new RegExp('[A-Za-z]');  
        if ( ( expCadena.test(e.target.value) && !expNopermitida.test(e.target.value) 
                && !expMenos.test(e.target.value) && !expMas.test(e.target.value) ) 
                || e.target.value===' '|| e.target.value==='') 
        {
            setNombre( e.target.value)            
        }		
	}; 


  function TablaEstr(auxDatos) {        
    let contadorTot=0
    if (auxDatos.length!==0) {
      auxDatos.forEach((regis)=>{
        contadorTot=regis.avc+contadorTot
      })    
    }
    
    return(        
    <TableContainer className={classes.tablaContainer} id="tamTablaReg"  >
    <Table stickyHeader aria-label="sticky table">
      <TableHead >    
        { totalGen.length!==0 ?
        <TableRow>
    
      
          <CelTitl index={3} titulo={  idusu === 1 || idusu === 19  ? 
            <IconButton onClick={exportarArch} size="small" >
            <Tooltip title="Exportar a Excel">
              <SaveIcon style={{color:'white'}} fontSize="small" />
            </Tooltip>
            </IconButton>
            :""} aline={"center"} estilo={{fontSize:"13px"}}  />   
          <CelTitl index={2} titulo={<span>{`${contadorTot} Total`} <br/> <strong>
            <NumberFormat value={totalGen.Total} displayType={'text'}  thousandSeparator={true}/></strong></span> } aline={"center"} />   
          <CelTitl index={1} titulo={ "Usuario" } aline={"left"} estilo={{fontSize:"13px"}} />                         
        </TableRow>
        :null }                   
      </TableHead>  
      <TableBody>         
      {auxDatos.map((elemnto,index) => {  
            const auxVal=registro?.id === elemnto.id ?true:false                                              
            return (                  
            <TableRow className={classes.tableRow} selected={ auxVal} 
            classes={{ hover: classes.hover, selected: classes.selected }} 
            key={index+1} onClick={ () => onChangeTable(elemnto) }  
            >   
            {celda("left", {width:"13px"}, "",index+3) }     
            {celda("center", {width:"10rem"},<NumberFormat value={ elemnto.avc} displayType={'text'}  thousandSeparator={true}/> ,index+2) }
            {celda("left", {width:"30rem"}, elemnto.nom ,index+1) }        
            </TableRow>              
            );                        
        })}                                                
        </TableBody>
        </Table>
    </TableContainer>        
    ); 
    }

    const llamada= listPagina.length !== 0 ?(TablaEstr(listPagina)):( sinDatos)
    const tabla = espera ?  (<Box pt={3}><LinearProgress/> </Box>) :( llamada )                                  
    const paginacion = !espera&&listPagina.length!==0 &&totalPaginas>1 ? generarFooter() : null;   

    return (
    <ModalInformativo
        setModalAbierto={setModalAbierto}  
        modalAbierto={modalAbierto}  titulo={`Avance por Usuario de ${fInicio} a ${fFinal}`}
        tamanio='lg'  
    >
      <Box display={"flex"} flexDirection={"row"}>
    <Box display={'flex'} flexDirection="column" style={{height: '29rem' }}>
        <TextField required id="Nombre-input" onChange={onChangeNom} style={{paddingBottom:.5+'rem',width:12+'rem',marginRight:"1.5rem"}}
            label="Buscar por Usuario" value={nombre} name='nombre'size="small" autoComplete='off' // defaultValue="Nombre"                                
        />
        <Card className={classes.estiloCard} style={{height:window.innerHeight-160}}>  
        {paginacion}                      
        {/* <Typography variant="body1" component="body1"></Typography>  */}
        { nombre.length!==0? filtro():  tabla}   
        </Card>
      
    </Box>  
      { esperaMap ? <Box width={"30rem"} mt={6} ml={2}><LinearProgress/> </Box> 
      : ( listMap.length!==0 ? <Box ml={2} width={"40rem"} height={"30rem"}> <MapaLeafAvanceUsuario listMapDet={listMap} /> </Box>
        : null )}
      </Box>
    </ModalInformativo>
    )
}

export default ModalAvanceUsuario